import { createContext } from "react";
import type {
  FundOption,
  SectionDescription,
  SectionTitle,
  UploadDocumentFn,
} from "./types";

export type FundControlContextType = {
  name?: string;
  funds: FundOption[];
  selectedFundId?: string;
  onFundSelect?: (fundId: string) => void;
  searchEnabled: boolean;
  sectionTitle: SectionTitle;
  sectionDescription?: SectionDescription;
  internalSelectedFundId?: string;
  setInternalSelectedFundId: (id: string | undefined) => void;
  handleFundsChange: (funds: FundOption[]) => void;
  handleSectionTitleChange: (title: SectionTitle) => void;
  editingFundId: string | null;
  setEditingFundId: (id: string | null) => void;
  editingFund: FundOption | null;
  setEditingFund: (fund: FundOption | null) => void;
  handleAddFund: () => void;
  handleDeleteFund: (fundId: string) => void;
  handleFundFieldChange: <K extends keyof FundOption>(
    field: K,
    value: FundOption[K],
  ) => void;
  handleBackToList: () => void;
  onUploadDocument?: UploadDocumentFn;
  error?: string;
  required?: boolean;
};

export const FundControlContext = createContext<FundControlContextType>(
  {} as FundControlContextType,
);
